import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ItemTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-itemtype',
  templateUrl: './itemtype.component.html',
  styleUrls: ['./itemtype.component.scss']
})
export class ItemTypeComponent implements OnChanges {


  itemtypeForm: FormGroup;
  itemtypeFormArray: FormGroup;
  control = new FormControl();
  @Input() itemtypes: ItemTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() itemtype = new EventEmitter<ItemTypeDto[]>()
  @Output() deleteItemTypeEvent = new EventEmitter<any>()

    selectedItemType: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createItemTypeForm();
    }

    createItemTypeForm() {
      this.itemtypeForm = this.fb.group({
        ItemTypeName: ['', Validators.required],
     
        id: null
        });
        this.itemtypeFormArray = this.fb.group({ ItemTypes: this.fb.array([])
          });
        this.setItemType();
    }

  // method to display itemtypes
  setItemType() {
    const control  = this.itemtypeFormArray.controls.ItemTypes as FormArray;
    this.itemtypes.forEach( e => {
      control.push(
        this.fb.group({
          ItemTypeName: e.ItemTypeName,
        
          id: e.id
        })
      );
    });
  }


  // method to add ItemType
  addItemType(value: ItemTypeDto) {
    const control  = this.itemtypeFormArray.controls.ItemTypes as FormArray;
    control.insert(0,
          this.fb.group({
            ItemTypeName: value.ItemTypeName,
          
            id: null
          })
       );
  }

  selectItemType(value) {}

  // method to delete itemtype from arrary list
  deleteItemType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.itemtypeFormArray.controls.ItemTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.itemtypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.itemtypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ItemTypeDto) {
    if(this.itemtypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.itemtypeFormArray.get('ItemTypes')['controls'][this.selectedIndex].patchValue({ItemTypeName: formValue.ItemTypeName});
    } else {
      this.addItemType(formValue);
    }
    this.selectedIndex = null;
    this.itemtypeForm.reset()
  }

  onEdit(index, value: ItemTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.itemtypeForm.patchValue({ItemTypeName: value.ItemTypeName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.itemtypeForm.reset();
  }

  onSubmit(formValue: ItemTypeDto[]) {
  this.itemtype.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteItemTypeEvent.emit(this.filteredDelete);
  }
  }

}
